import axios from '@/utils/http.js'

const user = {
    url: {
        get: "/SysUser/GetUserProfile",
        getPage: "/Account/GetList",
        add: "/SysUser/AddUser",
        update: "/SysUser/UpdateUser",
        delete: "/SysUser/DeleteUser",

        captcha: "/Captcha/GetImageCode",
        verifyCode: "/SysUser/VerifyCode",
    },
    get: function (params) {
        return axios.get(user.url.get, {
            params: params
        })
    },
    captcha: function (form) {
        return axios.post(user.url.captcha, form)
    },
    verifyCode: function (params) {
        return axios.get(user.url.verifyCode, {
            params: params
        })
    },
}

export default user